import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0","key":"svg-0"}],["path",{"d":"M3 14.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0","key":"svg-1"}]]

const IconBlendMode = createReactComponent('outline', 'blend-mode', 'BlendMode', __iconNode);

export default IconBlendMode;